// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/common.css
// module id = 813
// module chunks = 114276838955818